import React from 'react';

import { FirstOrderEnableText } from '../components/FirstOrderEnableText';
import { useFirstOrderEnableTextService } from '../services/useFirstOrderEnableTextService';

export const FirstOrderEnableTextContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const service = useFirstOrderEnableTextService();

  if (!service.min_required_amount) {
    return null;
  }
  return <FirstOrderEnableText price={service.min_required_amount} />;
};
